import {
  CREDIT_NOTE_TRANSACTION_DOC_HEADER_SELECTED,
  CREDIT_NOTE_TRANSACTION_DOC_NUMBER_FILTER,
  CREDIT_NOTE_TRANSACTION_DOCUMENT_TYPE_SELECTED,
} from "constants/ActionTypes";

const initialState = {
  docNumberFilter: "",
  documentTypeSelected: "",
  docHeaderTypeSelected: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CREDIT_NOTE_TRANSACTION_DOC_NUMBER_FILTER:
      return {
        ...state,
        docNumberFilter: action.payload,
      };
    case CREDIT_NOTE_TRANSACTION_DOCUMENT_TYPE_SELECTED:
      return {
        ...state,
        documentTypeSelected: action.payload,
      };
    case CREDIT_NOTE_TRANSACTION_DOC_HEADER_SELECTED:
      return {
        ...state,
        docHeaderTypeSelected: action.payload,
      };
    default:
      return state;
  }
};
